import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=82a9f67a&scoped=true"
import script from "./sdk.vue?vue&type=script&lang=ts"
export * from "./sdk.vue?vue&type=script&lang=ts"
import style0 from "./sdk.vue?vue&type=style&index=0&id=82a9f67a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a9f67a",
  null
  
)

export default component.exports